<div class="wrapper__form mt-3">
  <h4 class="wrapper__form__title">
    {{ 'carga-archivos.titulo' | translate }}
    <!--    <span class="govco-svg govco-info-circle color__cobalt"></span>-->
  </h4>
  <div class="row">
    <form [formGroup]="filesForm" class="row">
      <div class="col-md-6" *ngIf="mostrarTipo">
        <div class="form-group">
          <label for="tipo-archivo" class="form-label text3-tipografia-govco"
            >{{"carga-archivos.tipo" | translate}}
          </label><span class="text-danger"> *</span>
          <select
            formControlName="tipoAnexo"
            class="form-select"
            type="text"
            id="tipo-archivo"
            (change)="onChangeSelect($event)">
            <option value>{{ 'carga-archivos.seleccione' | translate }}</option>
            <option
              *ngFor="let item of archivosPrecargadosTipoAnexoDto"
              [value]="item.tipoAnexo.Id">
              {{ item.tipoAnexo.Categoria }}
            </option>
          </select>
        </div>
      </div>
      <div *ngIf="mostrarTipo==false">
        <span class="text-danger"> (*)</span> {{"carga-archivos.anexo_requerido" | translate}}</div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="archivos"></label>
          <div
            class="dropzone"
            id="dropzone"
            (drop)="onDrop($event)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"></div>
          <div *ngIf="mostrarTipo">
            <app-cargue-archivos
            *ngIf="selectedOption.Id && mostrarCargue"
            id="archivos1"
            [precargaArchivos]="archivosPrecargadoTipoSeleccionado"
            [extensiones]="selectedOption.Extensiones!"
            [tamanioMin]="minFileSize"
            [tamanioMax]="getTamanioMaxParaVista()"
            (cargar)="onFileSelect($event)"
            (eliminar)="removeFile($event)" />
          </div>
          <div *ngIf="mostrarTipo == false">
            <app-cargue-archivos
            *ngIf="mostrarCargue"
            id="archivos2"
            [precargaArchivos]="archivosPrecargadoTipoSeleccionado"
            [extensiones]="selectedOption.Extensiones!"
            [tamanioMin]="minFileSize"
            [tamanioMax]="getTamanioMaxParaVista()"
            (cargar)="onFileSelect($event)"
            (eliminar)="removeFile($event)" />
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
